<template>
	<span class="inline-loading-status" role="status" aria-live="polite">
		<v-progress-circular
			class="inline-loading-status__spinner"
			indeterminate
			:size="24"
			:width="3"
			aria-hidden="true"
		/>
		<span>{{ displayMessage }}</span>
	</span>
</template>

<script>
import { getInlineLoadingMessage } from './inlineLoadingStatus.mjs'

export default {
	name: 'MyInlineLoadingStatus',
	props: {
		confirming: {
			type: Boolean,
			default: false,
		},
		// 覆寫狀態文字（如「更新中」）；未指定時沿用 confirming 對應的預設文案
		message: {
			type: String,
			default: '',
		},
	},
	computed: {
		displayMessage() {
			return this.message || getInlineLoadingMessage(this.confirming)
		},
	},
}
</script>

<style scoped>
.inline-loading-status {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	white-space: nowrap;
	font-size: 1rem;
	line-height: 1;
}

.inline-loading-status__spinner {
	flex: 0 0 auto;
	color: currentColor;
}
</style>
